var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 67,
    viewBox: "0 0 70 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8411 25.6061V22.2369C18.8411 12.933 26.3336 5.39062 35.5761 5.39062C44.8185 5.39062 52.311 12.933 52.311 22.2369V25.6061C59.7049 25.6061 65.699 31.6401 65.699 39.0832C65.699 44.0717 63.0067 48.5454 59.005 50.8755M18.8411 25.6061C11.4471 25.6061 5.45312 31.6401 5.45312 39.0832C5.45312 44.0717 8.14545 48.5454 12.1471 50.8755M18.8411 25.6061C20.2899 25.6061 21.6849 25.8379 22.9916 26.2662M35.5761 32.3446V62.6679M35.5761 32.3446L45.6171 42.4524M35.5761 32.3446L25.5351 42.4524",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteUploadIcon);
export default __webpack_public_path__ + "static/media/WhiteUploadIcon.c8c610f645434ffe8b3e9674eee580fb.svg";
export { ForwardRef as ReactComponent };